import { piniaAuthRouterMiddleware } from '@onereach/auth-ui-module';
import { createPermissionsMiddleware } from '@onereach/permissions-ui';
import { createRouter, createWebHistory } from 'vue-router';

import config from '@/config';
import { useAuth } from '@/stores';

import routes from './routes';

const permissionsMiddleware = createPermissionsMiddleware();

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.afterEach((to) => {
  const pageTitle = to.meta.title as string | undefined;
  document.title = pageTitle ? `${pageTitle} | Billing` : 'Billing';
});

router.beforeEach(async (to) => {
  const authStore = useAuth();
  await piniaAuthRouterMiddleware(to, authStore, config.AUTH_UI_URL);

  if (to.meta.requiresAuth && authStore.authorized) {
    return permissionsMiddleware(to);
  }
});

export default router;
